/** Marketing nav children (שיווק) — desktop-first; mobile shows a gate instead of page UI. */
export const MARKETING_MOBILE_ENTRY_PATH = '/marketing/desktop-only';

const MARKETING_DESKTOP_ONLY_PREFIXES = [
  MARKETING_MOBILE_ENTRY_PATH,
  '/customers',
  '/campaigns',
  '/sequences',
  '/triggers',
  '/templates',
  '/arbox-automations',
] as const;

export function isMarketingDesktopOnlyPath(pathname: string | null): boolean {
  if (!pathname) return false;
  return MARKETING_DESKTOP_ONLY_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
